class FooterNewsletter extends HTMLFormElement {
  constructor() {
    super();
    this.successDisplay = this.querySelector(".js-success-display");
    this.errorDisplay = this.querySelector(".js-error-display");
  }

  connectedCallback() {
    this.addEventListener("submit", async (e) => {
      e.preventDefault();

      const email = this.email.value;

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        email: email,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
      };

      try {
        const response = await fetch(
          "https://jolly-render-services.onrender.com/la-bourse-aux-livres/newsletter-subscribe",
          requestOptions
        );
        if(response.ok) {
          this.successDisplay.setAttribute('aria-hidden', false);
          this.errorDisplay.setAttribute('aria-hidden', true);
        } else {
          this.successDisplay.setAttribute('aria-hidden', true);
          this.errorDisplay.setAttribute('aria-hidden', false);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }
}

customElements.define("footer-newsletter", FooterNewsletter, { extends: "form" });
